let appInfo = {}

/**
 * 转化为int类型
 * 如果不是无法转换为有效的int类型，则返回空字符串
 */
function parseToInt(num) {
  if (!num) return ''
  num = parseInt(num, 10)
  return isNaN(num) ? '' : num
}

const platform = (() => {
  let u = navigator.userAgent
  return {
    iOS: /ipad|iphone|mac/i.test(u),
    Android: /android/i.test(u),
    Weixin: /micromessenger/i.test(u)
  }
})()

/**
 * 解析url param
 */
function getQueryStringArgs() {
  let qs = location.search.length > 0 ? location.search.substring(1) : ''
  let args = {}
  let items = qs.length ? qs.split('&') : []
  let item = null
  let name = null
  let value = null
  let i = 0
  let len = items.length
  let regx = new RegExp('(.*)=([^$].*)$', 'i')

  for (i = 0; i < len; i++) {
    item = items[i].match(regx)
    if (!item) {
      continue
    }
    // decodeURIComponent解码
    name = decodeURIComponent(item[1])
    // 移除某些版本的意外字符（换行符）
    const s = item[2].replace(/%0A/g, '')
    value = decodeURIComponent(s)
    if (name.length && !args[name]) {
      args[name] = value
    }
  }

  return args
}

/**
 * 刷新来自客户端goods.getAppInfo的用户信息
 */
function refreshAppInfo(callback = () => {}) {
  window.WEB_CALLBACK_APPINFO = json => {
    let result = json
    if (typeof json === 'string') {
      result = JSON.parse(json)
    }

    updateAppInfo(result)

    callback(result)
  }

  let result

  let loadAppinfo = () => {
    if (window.goods.getAppInfo || window.goods.getClientInfo) {
      try {
        if (window.goods.getAppInfo) {
          result = window.goods.getAppInfo(
            JSON.stringify({
              callback: 'WEB_CALLBACK_APPINFO'
            })
          )
        } else {
          window.goods.getClientInfo('WEB_CALLBACK_APPINFO')
        }
      } catch (err) {
        result = window.goods.getAppInfo()
      }
      if (result) {
        result = typeof result === 'string' ? JSON.parse(result) : result
        updateAppInfo(result)
        callback(result)
      }
    }
  }

  if (window.goods) {
    loadAppinfo()
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(function() {
        //获取应用信息
        let getAppInfo = function(params) {
          /**
           * 覆盖ios经典版客户端的本地方法（因为客户端存在着不为人知的坑爹错误）
           *
           */
          try {
            if (!params) return
            /* eslint-disable no-undef */
            let obj = new JSBridgeObj()
            obj.addObject('task', 'getAppInfo')
            obj.addObject('jsonParams', JSON.parse(params))
            obj.sendBridgeObject()
          } catch (err) {
            // console.log(err);
          }
        }

        getAppInfo(
          JSON.stringify({
            callback: 'WEB_CALLBACK_APPINFO'
          })
        )
      }, 500)
    })
  }
}

/**
 * 更新app信息
 *
 * @param {object} target
 *
 * @memberOf appInfo
 */
function updateAppInfo(target) {
  let app = {}

  //键值全部转换为小写，防止部分参数小写部分大写的异常情况
  for (let key in target) {
    app[key.toLowerCase()] = target[key]
  }

  appInfo = { ...appInfo, ...app }

  console.log('用户信息更新：', appInfo)
}

function getParam(name) {
  // 键值全部转换为小写，防止部分参数小写部分大写的异常情况
  return appInfo[name.toLocaleLowerCase()] || ''
}

// 初始化参数
updateAppInfo(getQueryStringArgs())
refreshAppInfo()

export default {
  /**
   * 是否为手机号实名登陆
   *
   * @memberOf appInfo
   */
  get isPhone() {
    let loginType = parseInt(getParam('loginType'), 10)
    let isPhoneNum = getParam('isPhoneNum')

    return loginType === 2 && (isPhoneNum || isPhoneNum === '')
  },

  /**
   * 老版token
   */
  get webAuthToken() {
    let token = getParam('webAuthToken')

    if (!token) {
      return ''
    }

    if (platform.Android) {
      token = decodeURIComponent(token)
    }

    return token
  },

  /**
   * 新版token
   */
  get emoneyToken() {
    let token = ''
    if (process.env.NODE_ENV === 'production' && process.env.__ENV !== 'test') {
      token = getParam('emoneyToken')
    }
    return token
  },

  /**
   * 益盟股票token
   */
  get authorizationToken() {
    return getParam('token')
  },

  /**
   * 版本
   */
  get mv() {
    let currentMv = getParam('mv') || getParam('appVersion')
    if (currentMv) {
      currentMv = currentMv.toString().replace(/\./g, '')
    }
    return parseToInt(currentMv)
  },

  /**
   * 平台
   * 2  - 益盟经典版
   * 4  - 益盟股票
   * 15 - 益盟加强版
   */
  get pd() {
    return parseToInt(getParam('pd') || getParam('pid') || getParam('productId')) || 15
  },

  /**
   * 平台号
   * 9  - 安卓
   * 10 - 苹果
   */
  get ar() {
    let ar = getParam('ar')
    let platform = getParam('platform')

    if (!ar && platform) {
      ar = platform === 'android' ? '10' : '9'
    }

    return parseToInt(ar)
  },

  /**
   * 渠道号
   */
  get vd() {
    return parseToInt(getParam('vd') || getParam('channelId'))
  },

  /**
   * 登录类型
   * 2 - 手机号登录
   * 0 - 匿名登录
   */
  get loginType() {
    return parseToInt(getParam('loginType'))
  },

  platform,
  getParam,
  refreshAppInfo
}



// WEBPACK FOOTER //
// ./src/assets/js/appInfo.js